<template>
  <!-- <div class="infobar"> -->
  <div class="balls-list page-pad infobar--flex flex flex-wrap">
    <!-- <div
      class="flex align-start justify-start pb-2xl pt-2xl"
      :class="[orders.length ? 'w100' : '']"
    > -->
    <!-- <div v-if="!orders.length" class="status-ball new-user mr-l">
        <span>CREATE YOUR FIRST ORDER</span>

        <router-link class="btn-neworder" to="/order">
          <i class="fal fa-plus"></i>
        </router-link>
      </div> -->
    <div
      class="infobar--balls w100 flex-none align-start justify-start pb-2xl"
      :class="[loadingOrders ? 'loading' : '']">
      <!-- : orders.length ? 'no-status'  -->
      <preloader
        key="preloader"
        v-if="loadingOrders"
        v-bind:title="localize('loading_status')"
      ></preloader>
      <template v-else>
        <status-ball
          :class="['flex-none', status.id === statusFilter ? 'active' : '']"
          v-for="status in orderStatusList"
          :locale="locale"
          :key="status.id"
          :info="status"
          :total="getTotal(status)"
          :active="status.id === statusFilter"
          @status-updated="updateStatusFilter"
          @click.native="updateStatusFilter(status.id)"
          v-tooltip.bottom="{
            content: status.id === 12 ? 'MCENTER awaiting physical goods' : null
          }"
        ></status-ball>
      </template>
    </div>
  </div>
  <!-- </div> -->
  <!-- </div> -->
</template>
<script>
// import ToggleSwitch from "@/components/ToggleSwitch.vue";
import StatusBall from "@/components/StatusBall.vue";
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      localTypeFilter: 1,
      fromFilter: 3,
      fromFilterList: [
        {
          label: "Past week",
          value: 1
        },
        {
          label: "Past month",
          value: 2
        },
        {
          label: "Last 3 month",
          value: 3
        },
        {
          label: "A full Year",
          value: 4
        }
      ]
    };
  },
  mounted() {
    this.updateTimeRangeFilter(parseInt(this.fromFilter));
    if (this.typeFilter !== this.localTypeFilter) {
      this.localTypeFilter = this.typeFilter;
    }

    //this.localize('active').toUpperCase()
    
  },
  watch: {
    fromFilter() {
      this.updateTimeRangeFilter(parseInt(this.fromFilter));
    },
    typeFilter() {
      if (this.typeFilter !== this.localTypeFilter) {
        this.localTypeFilter = this.typeFilter;
      }
    },
    localTypeFilter() {
      this.updateTypeFilter(parseInt(this.localTypeFilter));
    }
  },
  components: {
    StatusBall
    // ToggleSwitch
  },
  methods: {
    ...mapActions([
      "updateTimeRangeFilter",
      "updateStatusFilter",
      "updateTypeFilter"
    ]),
    getTotal(status) {
      return _.filter(this.filteredOrdersByType, { StatusID: status.id })
        .length;
    }
    // ,
    // filterByStatus() {
    //   console.log("filter bys tatus: ", status);
    // }
  },
  computed: {
    ...mapState([
      "locale",
      "orders",
      "loadingOrders",
      "statusFilter",
      "typeFilter",
      "$device"
    ]),
    ...mapGetters([
      "isDoctor",
      "isDistributor",
      "isMcenter",
      "fullName",
      "orderStatusList",
      "filteredOrdersByType"
    ]),
    sortedTypeFilterList() {
      let arr = [
        { label: "ACTIVE", value: 1 },
        { label: "ARCHIVE", value: 3 }
      ];
      if (this.isDoctor) {
        arr.push({ label: "DRAFTS", value: 2 });
      }
      return _.sortBy(arr, "value");
    }
  }
};
</script>
<style lang="stylus" scoped>

.balls-list
  background-color #f7f7f7

.status-ball.new-user
  position relative
  background #fff
  //border 1px solid gray_7
  flex none
  span
    font-size 14px
    color gray_7
    font-weight 400
    text-align center
    padding 0 30px
  .btn-neworder
    round(50)
    background blue_brand
    _flex(row, wrap, center, center)
    position absolute
    bottom 0
    left 75%
    transform translate(-50%, 10%)
    text-align center
    overflow hidden
    backface-visibility hidden
    span
    i
      font-size 24px
      font-weight 300
      color #fff
      line-height 1.3
</style>

<style lang="stylus" scoped>
.infobar
  position relative
  min-height 24vh
  background #f2f2f2
  // _flex(row, wrap, center, flex-start)
  .drafts-toggle-btn
    background blue_brand
    outline 0
    border 0
    box-shadow none
    height 40px
    min-width 120px
    max-width 170px
    width 8vw
  &--flex
    width 100%
    align-items flex-start
    justify-content flex-start
  &--balls
    max-width 100%
    _flex(row, nowrap, center, space-between)
    position relative
    &.loading
      background rgba(blue_brand, 0.1)
      height 30vh
    +below(1400px)
      _flex(row, wrap, center, center)
    +below(815px)
      _flex(row, wrap, center, center)
    & > *
      margin 0 10px
      +below(1400px)
        margin 0 5px 10px
      &:first-child
        margin-left 0
      &:last-child
        margin-right 0
    // &.no-status > *
    //   &:first-child
    //     opacity 0.45
    //   &:nth-child(2)
    //     opacity 0.38
    //   &:nth-child(3)
    //     opacity 0.32
    //   &:nth-child(4)
    //     opacity 0.25
    //   &:last-child
    //     display none
    //   &:nth-last-child(2)
    //   &:nth-last-child(3)
    //     display none
  &--showmenu
    font-size 14px
    _flex(row, wrap, center, flex-start)
    +desktop()
      a
        transition color 0.2s ease-out
        &:hover
          color blue_brand
  &--status
    height 60%
    &--person
      h3
        font-size 28px
        padding-bottom 0
        margin-bottom 0
</style>
